import { createFileRoute } from '@tanstack/react-router';
import { useSampleSet } from '../../../../../contexts/SampleSetContext';
import MetadataTab from '../../../../../pages/experiments/sampleManagement/MetadataTab';

export const Route = createFileRoute(
  '/_authenticated/_navbar/experiments/$sampleSetId/metadata'
)({
  staticData: { ddViewName: 'experiments-metadata-tab' },
  component: MetadataRouteComponent,
});

function MetadataRouteComponent() {
  const { sampleSet } = useSampleSet();

  if (!sampleSet) {
    return null;
  }

  return <MetadataTab selectedSampleSet={sampleSet} />;
}
